"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var errorMessageHoc_1 = require("../../../../../common/components/presentation/Error/errorMessageHoc");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var paymentType_1 = require("../../../../common/constants/paymentType");
var ConfirmationReserveOnlineWebpay_1 = require("./ConfirmationReserveOnlineWebpay");
var ConfirmationReserveOnline2C2P_1 = require("./ConfirmationReserveOnline2C2P");
var ConfirmationReserveOnlineVisanet_1 = require("./ConfirmationReserveOnlineVisanet");
var ConfirmationReserveOnlineMercadoPago_1 = require("./ConfirmationReserveOnlineMercadoPago");
var ConfirmationReserveOnline = function () {
    var paymentProvider = usePlatformConfig_1.default().platformConfig.paymentProvider;
    if (paymentProvider === paymentType_1.default.WEBPAY) {
        return <ConfirmationReserveOnlineWebpay_1.default />;
    }
    if (paymentProvider === paymentType_1.default['2C2P']) {
        return <ConfirmationReserveOnline2C2P_1.default />;
    }
    if (paymentProvider === paymentType_1.default.VISANET) {
        return <ConfirmationReserveOnlineVisanet_1.default />;
    }
    if (paymentProvider === paymentType_1.default.MERCADOPAGO) {
        return <ConfirmationReserveOnlineMercadoPago_1.default />;
    }
    return <div data-test="confirmation_page:no_payment_provider">There is no payment provider</div>;
};
exports.default = errorMessageHoc_1.default(ConfirmationReserveOnline);
